var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnderline08(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 310 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.335 15.99a1524.264 1524.264 0 0159.516-5.48 1503.032 1503.032 0 01119.195-3.844 1498.749 1498.749 0 01126.588 6.367c2.71.248 3.331-6.356.6-6.609a1514.513 1514.513 0 00-59.847-4.349c-19.95-1.045-39.914-1.7-59.879-1.95a1506.02 1506.02 0 00-59.614.411c-19.965.536-39.93 1.477-59.881 2.802a1516.715 1516.715 0 00-59.82 5.199c-2.464.268-4.935.534-7.4.813-2.726.322-2.182 6.94.542 6.64z",
    fill: "#121318"
  })));
}

export default SvgUnderline08;